// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3Acix","footer":"ModalUpdate_footer__22T8B"};